// Judge.me Configuration
// Replace these values with your actual Judge.me settings
window.JudgeMeConfig = {
	// Cloudflare Worker endpoint (replace with your actual worker URL after deployment)
	workerEndpoint: 'https://reviews-worker.support-bd5.workers.dev', // Update this after deploying

	// Optional settings
	defaultPerPage: 10,
	enableWriteReview: true,
	enableImages: true,
	enableVideos: true,

	// Caching settings
	cache: {
		enabled: true, // Enable/disable caching
		duration: {
			reviews: 24 * 60 * 60 * 1000, // 24 hours (1 day) for reviews
			summary: 48 * 60 * 60 * 1000, // 48 hours (2 days) for summary data
		},
		// Enable debug logging for cache operations
		debug: false,
	},

	// Custom styling options
	starColor: '#ffd700',
	emptyStarColor: '#ddd',

	// Language settings
	lang: {
		noReviews: 'No reviews yet.',
		writeReview: 'Write a Review',
		reviewsHeading: 'Customer Reviews',
		basedOn: 'Based on',
		review: 'review',
		reviews: 'reviews',
		previous: 'Previous',
		next: 'Next',
		page: 'Page',
		anonymous: 'Anonymous',
		loadingError: 'Unable to load reviews at this time.',
	},
};
